import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { getPageTitleForPath } from "utils/pageTitles";

export const APP_NAME = "Kothar Dashboard";

let currentBaseTitle = APP_NAME;

export const formatDocumentTitle = (pageTitle, appName = APP_NAME) => {
  if (!pageTitle) return appName;
  return `${pageTitle} | ${appName}`;
};

export const getCurrentBaseTitle = () => currentBaseTitle;

export const setBaseDocumentTitle = (title) => {
  currentBaseTitle = title || APP_NAME;
  document.title = currentBaseTitle;
};

export const useDocumentTitle = (title, appName = APP_NAME) => {
  useEffect(() => {
    setBaseDocumentTitle(formatDocumentTitle(title, appName));
  }, [title, appName]);
};

/** Set the browser tab title for the current page. */
const DocumentTitle = ({ title, appName = APP_NAME }) => {
  useDocumentTitle(title, appName);
  return null;
};

/** Sets the title from the current route, or falls back to the app name. */
export const RouteDocumentTitle = () => {
  const { pathname } = useLocation();
  const title = getPageTitleForPath(pathname);

  useDocumentTitle(title);
  return null;
};

export default DocumentTitle;
